// src/Games.js
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import SideBar from "../SideBar/SideBar";
import "./Games.css";

const GamesTable = ({ serverIP }) => {
  const [games, setGames] = useState([]);
  const [selectedGame, setSelectedGame] = useState('');
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teamsLoading, setTeamsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await axios.get(`${serverIP}/v1/games/list`);
        const gamesList = response.data;
        setGames(gamesList);

        const savedGame = Cookies.get('selectedGame');
        if (savedGame && gamesList.includes(savedGame)) {
          setSelectedGame(savedGame);
        } else if (gamesList.length > 0) {
          const initialGame = gamesList[0];
          setSelectedGame(initialGame);
          Cookies.set('selectedGame', initialGame, { 
            expires: 7, 
            path: '/' // Добавляем явное указание корневого пути
          });
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, []);

  useEffect(() => {
    const fetchTeams = async () => {
      if (!selectedGame) return;
      
      try {
        setTeamsLoading(true);
        const response = await axios.get(
          `${serverIP}/v1/game/teams?game_name=${encodeURIComponent(selectedGame)}`
        );
        setTeams(response.data);
      } catch (err) {
        setError(`Ошибка загрузки команд: ${err.message}`);
      } finally {
        setTeamsLoading(false);
      }
    };

    fetchTeams();
  }, [selectedGame]);

  const handleGameChange = (e) => {
    const game = e.target.value;
    setSelectedGame(game);
    Cookies.set('selectedGame', game, { expires: 7 });
  };

  if (loading) {
    return <div>Загрузка данных...</div>;
  }

  if (error) {
    return <div>Ошибка: {error}</div>;
  }

  return (
    <div className="games-container">
      <h2>Доступные игры</h2>
      
      {games.length > 0 ? (
        <select 
          className="games-dropdown"
          value={selectedGame}
          onChange={handleGameChange}
        >
          {games.map((game, index) => (
            <option key={index} value={game}>
              {game}
            </option>
          ))}
        </select>
      ) : (
        <div>Нет доступных игр</div>
      )}

      <div className="teams-section">
        <h3>Команды для игры: {selectedGame}</h3>
        
        {teamsLoading ? (
          <div>Загрузка списка команд...</div>
        ) : teams.length > 0 ? (
          <table className="teams-table">
            <thead>
              <tr>
                <th>Пользователь</th>
                <th>Название текущей команды</th>
              </tr>
            </thead>
            <tbody>
              {teams.map((team) => (
                <tr key={team.team_id}>
                  <td>{team.team_login}</td>
                  <td>{team.team_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Нет зарегистрированных команд для этой игры</div>
        )}
      </div>
    </div>
  );
};

function Games({ isAdmin, serverIP}) {
  return (
    <div > {/*className="App">
    {/* <SideBar 
        blueGames={{ backgroundColor: "#0170ba", color: "#fff" }} 
        isAdmin={isAdmin}
      />*/}
      <div className="content-wrapper">
        <GamesTable 
          isAdmin={isAdmin}
          serverIP={serverIP}
        />
      </div>
    </div>
  );
}

export default Games;